import { useEffect, useRef, useState } from 'react';

import { debounce } from 'src/utils/debounce';

export const usePlacesService = ({ enable }: { enable: boolean }) => {
  const placesService = useRef<google.maps.places.PlacesService | null>(null);
  const autocompleteService = useRef<google.maps.places.AutocompleteService | null>(null);
  const [placePredictions, setPlacePredictions] = useState<google.maps.places.AutocompletePrediction[]>([]);
  const [placeInputValue, setPlaceInputValue] = useState<string>('');

  const [isPlacePredictionsLoading, setIsPlacePredictionsLoading] = useState(false);

  const getPlacePredictions = debounce((request: google.maps.places.AutocompletionRequest) => {
    autocompleteService.current?.getPlacePredictions(request, (result) => {
      if (result) {
        setPlacePredictions(result);
      }
      setIsPlacePredictionsLoading(false);
    });
  }, 400);

  const reset = () => {
    setPlacePredictions([]);
  };

  useEffect(() => {
    if (enable) {
      if (!autocompleteService.current && (window as any).google) {
        autocompleteService.current = new google.maps.places.AutocompleteService();
      }
      if (!placesService.current && (window as any).google) {
        placesService.current = new google.maps.places.PlacesService(document.createElement('div'));
      }
    }
  }, [enable]);

  return {
    autocompleteService: autocompleteService.current,
    placesService: placesService.current,
    placePredictions: placeInputValue ? placePredictions : [],
    getPlacePredictions: (opt: google.maps.places.AutocompletionRequest) => {
      if (opt.input) {
        setPlaceInputValue(opt.input);
        setIsPlacePredictionsLoading(true);
        getPlacePredictions(opt);
        return;
      }
      setPlacePredictions([]);
      setPlaceInputValue('');
      getPlacePredictions(opt);
      setIsPlacePredictionsLoading(false);
    },
    resetPlacePredictions: reset,
    isPlacePredictionsLoading,
  };
};
